import { IFilterComponentConfiguration } from "src/app/shared/components/filter-component/filter-component.component";
import { ColumnDataType } from "src/app/shared/model/resource";

export const testesFilterConfiguration: IFilterComponentConfiguration = {
    colunas: [
        {
            field: 'ativo',
            label: 'Ativo/Inativo',
            defaultValue: true,
            type: ColumnDataType.Checkbox,
        }
    ]
};